import { createBrowserRouter } from 'react-router-dom'
import { lazy, Suspense, ComponentType } from 'react'
import RootLayout    from '@/layouts/RootLayout'
import NotFoundPage  from '@/pages/NotFoundPage'
import LoadingSpinner from '@/components/ui/LoadingSpinner'

function wrap(factory: () => Promise<{ default: ComponentType }>) {
  const Component = lazy(factory)
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  )
}

export const router = createBrowserRouter([
  {
    path:         '/',
    element:      <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: wrap(() => import('@/pages/HomePage')) },
      { path: 'apartments',      element: wrap(() => import('@/pages/ApartmentsPage')) },
      { path: 'apartments/:slug', element: wrap(() => import('@/pages/ApartmentDetailPage')) },
      { path: 'local-area',      element: wrap(() => import('@/pages/LocalAreaPage')) },
      { path: 'gallery',         element: wrap(() => import('@/pages/GalleryPage')) },
      { path: 'reviews',         element: wrap(() => import('@/pages/ReviewsPage')) },
      { path: 'about',           element: wrap(() => import('@/pages/AboutPage')) },
      { path: 'enquire',         element: wrap(() => import('@/pages/EnquirePage')) },
      { path: 'contact',         element: wrap(() => import('@/pages/ContactPage')) },
      { path: 'terms',           element: wrap(() => import('@/pages/TermsPage')) },
      { path: 'access',          element: wrap(() => import('@/pages/AccessPage')) },
    ],
  },
])
